<template>
  <rest-list-page
    :page-title="pageTitle"
    :breadcrumbs="breadcrumbs"
    :fetch-endpoint="fetchEndpoint"
  >
    <template slot="actions" v-if="!readonly">
      <el-button
        :disabled="!$can('createProjectItem')"
        type="primary"
        icon="el-icon-circle-plus-outline"
        @click="createSite"
        data-qa="create-site-button"
      >
        {{ $t('Sites_Button_CreateSite') }}
      </el-button>
    </template>

    <template slot="table">
      <rest-list-column :title="$t('Sites_Table_Name')" prop="name">
        <template v-slot:default="scope">
          <router-link :to="rowUpdateRoute(scope.row)">
            {{ scope.rowValue(scope) }}
          </router-link>
        </template>
      </rest-list-column>
      <el-table-column
        :label="$t('Sites_Table_LastPublished')"
        prop="published"
        :sortable="false"
        :filterabl="false"
      />
      <el-table-column
        :label="$t('Sites_Table_NoPages')"
        prop="page_count"
        :filterable="false"
        :sortable="false"
      />
      <el-table-column
        :label="$t('Sites_Table_LastUpdated')"
        prop="updated"
        :filterable="false"
        :sortable="false"
      />
      <rest-list-column-actions v-if="readonly">
        <template slot-scope="scope">
          <rest-list-action-view :route="rowViewRoute(scope.row)" />
        </template>
      </rest-list-column-actions>
      <rest-list-column-actions v-else>
        <template slot-scope="scope">
          <rest-list-action-update :route="rowUpdateRoute(scope.row)" />
          <rest-list-action-copy :route="rowCopyRoute(scope.row)" />
          <rest-list-action-delete
            :endpoint="rowDeleteEndpoint(scope.row)"
            :name="scope.row.name"
          />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page>
</template>

<script>
import RestListPage from '@/common/components/rest/RestListPageNew'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { siteStatusEnum } from '@/modules/sites/enum/SiteStatusEnum'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionView from '@/common/components/rest/RestListActionView'
import RestListActionUpdate from '@/common/components/rest/RestListActionUpdate'
import RestListActionCopy from '@/common/components/rest/RestListActionCopy'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import { mapGetters } from 'vuex'

export default {
  name: 'SitesListPage',
  components: {
    RestListActionDelete,
    RestListActionCopy,
    RestListActionUpdate,
    RestListActionView,
    RestListColumnActions,
    RestListColumn,
    RestListPage
  },

  data() {
    return {
      siteStatusEnum
    }
  },

  mounted() {
    if (!this.isMicrositesAvailable) {
      this.$router.push('/')
    }
  },

  computed: {
    ...mapGetters(['isMicrositesAvailable']),
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('Sites_Breadcrumb_Content')
        },
        {
          label: this.$t('Sites_Breadcrumb_Sites')
        }
      ]
    },

    readonly() {
      return !this.$can('ContentSites:FullAccess')
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'sites'
      })
    }
  },

  methods: {
    createSite() {
      this.$router
        .push(
          projectRoute({
            name: 'SiteCreate'
          })
        )
        .catch(() => {})
    },

    rowViewRoute(row) {
      return projectRoute({
        name: 'SiteView',
        query: { id: row.id }
      })
    },

    rowUpdateRoute(row) {
      return projectRoute({
        name: 'SiteUpdate',
        query: { id: row.id }
      })
    },

    rowCopyRoute(row) {
      return projectRoute({
        name: 'SiteCopy',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `sites/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/sites/pages/SitesListPage.vue